import { COMPANY_FIRST_NAME, REFERRAL_CARD_IMG } from "@/_constant";
import type { DashboardContentProps } from "./types";
import { Button } from "@/_component/Common";
import { hasKnowMoreCard, isDashboardPlanExpired } from "./dashboard-profile-card.resolver";
import ProfileCardKpis from "./ProfileCardKpis";
import { KnowMore, RenewCard } from "@/_component/shared";
import ProfileCardContent from "./ProfileCardContent";

const BusinessDeveloperContent = (props: DashboardContentProps) => {
  
  const isPlanExpired = isDashboardPlanExpired(props.profile, props.config);
  const hasKnowMore = hasKnowMoreCard(props.config);

  return (
    <>
      <ProfileCardContent {...props}/>
     
      <div className="row mt-3">
        <ProfileCardKpis profile={props.profile} kpis={props.config.extraKpis || []} className="col-12" executeAction={props.executeAction} />
      </div>

      {props.config.referralAction && (
        <div className="bg-white rounded-4 p-3 mt-3 d-flex justify-content-between shadow-sm border overflow-hidden">
          <div className="d-flex flex-column justify-content-between align-items-start">
            <div>
              <p className="fs-5 fw-bold">Onboard people on {COMPANY_FIRST_NAME} &amp; grow with us</p>
              <p className="text-muted mb-2">Share your referral link with people</p>
            </div>
            <Button primary outline rounded onClick={() => props.executeAction(props.config.referralAction!)}>
              Refer Now <i className="bi bi-chevron-right ms-1" />
            </Button>
          </div>
          <img src={REFERRAL_CARD_IMG} className="mb-n4 me-n3" alt="Share your referral code" style={{ maxHeight: 130 }} />
        </div>
      )}
    </>
  );
}

export default BusinessDeveloperContent;
